var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hr',{style:({margin: ((_vm.data.marginY) + "px 0 !important")})})}
var staticRenderFns = []

export { render, staticRenderFns }